import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const MarketplacePage = lazy(() => import('../pages/marketplace/page'));
const TournamentsPage = lazy(() => import('../pages/tournaments/page'));
const CoursesPage = lazy(() => import('../pages/courses/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const DonationsPage = lazy(() => import('../pages/donations/page'));
const CommunityPage = lazy(() => import('../pages/community/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const OrganizationsPage = lazy(() => import('../pages/organizations/page'));
const KidsPage = lazy(() => import('../pages/kids/page'));
const YouthPage = lazy(() => import('../pages/youth/page'));
const SeniorsPage = lazy(() => import('../pages/seniors/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/marketplace',
    element: <MarketplacePage />
  },
  {
    path: '/tournaments',
    element: <TournamentsPage />
  },
  {
    path: '/courses',
    element: <CoursesPage />
  },
  {
    path: '/events',
    element: <EventsPage />
  },
  {
    path: '/donations',
    element: <DonationsPage />
  },
  {
    path: '/community',
    element: <CommunityPage />
  },
  {
    path: '/register',
    element: <RegisterPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/organizations',
    element: <OrganizationsPage />
  },
  {
    path: '/kids',
    element: <KidsPage />
  },
  {
    path: '/youth',
    element: <YouthPage />
  },
  {
    path: '/seniors',
    element: <SeniorsPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
